import React from "react";

const LayoutSignedOut = ({ className = "body-sign", ...props }) => {
  return <section className={className}>{props.children}</section>;
};

export default LayoutSignedOut;
